// Ongoing meeting interaction
export const JOIN_MEETING = 'JOIN_MEETING';
export const PROMPT_JOIN_MEETING = 'PROMPT_JOIN_MEETING';
export const START_MEETING = 'START_MEETING';
export const RESUME_MEETING = 'RESUME_MEETING';
export const LEAVE_MEETING = 'LEAVE_MEETING';
export const STOP_MEETING = 'STOP_MEETING';
// Settings
export const FETCH_PLANNINGS = 'FETCH_PLANNINGS';
export const DELETE_PLANNING = 'DELETE_PLANNING';
export const SET_PLANNING = 'SET_PLANNING';
export const SET_PLANNING_STEP = 'SET_PLANNING_STEP';
export const DELETE_PLANNING_STEP = 'DELETE_PLANNING_STEP';

export default {
  JOIN_MEETING,
  PROMPT_JOIN_MEETING,
  START_MEETING,
  RESUME_MEETING,
  LEAVE_MEETING,
  STOP_MEETING,

  FETCH_PLANNINGS,
  DELETE_PLANNING,
  SET_PLANNING,
  SET_PLANNING_STEP,
  DELETE_PLANNING_STEP,
};
